export default "__VITE_ASSET__CA3iroeG__"